



























import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { Quiz } from '@/models/quiz';


@Component
export default class HomeQuizCard extends Vue {

    public quiz: Quiz = {} as Quiz;
    public totalAnswers = 0;
    public correctAnswers = 0;
    public answerPercentage = 0;
    public correctPercentage = 0;

    public created() {
        this.update();
    }

    public async update() {
        await this.$store.waitUntilReady();
        if (!this.$store.quiz || !this.$store.quizAnswers) return;
        this.quiz = this.$store.quiz;

        const quizQuestionIds = this.quiz.questions.map(q => q.id);
        const quizAnswers = this.$store.quizAnswers.filter(a => quizQuestionIds.includes(a.questionId));
        const quizQuestionCount = this.quiz.questions.length;

        this.totalAnswers = quizAnswers.length;
        this.correctAnswers = quizAnswers.filter(a => a.correct).length;
        this.answerPercentage = quizQuestionCount > 0 ? Math.floor(this.totalAnswers * 100 / quizQuestionCount) : 0;
        this.correctPercentage = this.totalAnswers > 0 ? Math.floor(this.correctAnswers * 100 / this.totalAnswers) : 0;
    }
}
